import React from 'react';
import { useInView } from '../../hooks/useInView';

const TimelineItem = ({ year, title, desc, index, odd }) => {
  const [ref, inView] = useInView();
  return (
    <div className={`timeline-item ${inView ? 'visible' : ''}`} ref={ref} style={{ transitionDelay: `${index * 0.15}s` }}>
      <div className={`timeline-photo ${odd ? '' : 'order-reverse'}`}><div className="timeline-photo-frame"><img src={`https://picsum.photos/seed/archive${index + 1}/400/500`} alt={year} /></div></div>
      <div className="timeline-dot" />
      <div className="timeline-info">
        <div className="timeline-year">{year}</div>
        <h3 className="timeline-title">{title}</h3>
        <p className="timeline-desc">{desc}</p>
      </div>
    </div>
  );
};

export const Timeline = () => {
  const [ref, inView] = useInView();
  const items = [
    { year: '1890', title: 'Рождение фотографии', desc: 'Первые снимки на стеклянных пластинках. Мир только начинал учиться сохранять мгновения.' },
    { year: '1910', title: 'Золотой век портрета', desc: 'Фотостудии расцветают по всей стране. Каждый портрет — произведение искусства.' },
    { year: '1930', title: 'Улицы говорят', desc: 'Уличная фотография становится новым жанром. Городские пейзажи и лица прохожих.' },
    { year: '1950', title: 'Новая эпоха', desc: 'Цветная фотография меняет всё. Мир становится ярче, но чёрно-белые снимки хранят особую магию.' }
  ];

  return (
    <section id="timeline">
      <div className="section-header reveal" ref={ref}><div className="section-number">01 — ХРОНОЛОГИЯ</div><h2 className="section-title">Путешествие <em>сквозь время</em></h2><div className="section-line" /></div>
      <div className="timeline">
        <div className="timeline-line" />
        {items.map((it, i) => <TimelineItem key={i} {...it} index={i} odd={i % 2 === 0} />)}
      </div>
    </section>
  );
};